module.exports = {
  WEB_SOCKET_APP_PORT: 3200,

  ITEM_FEN: { weight: 990, name: 'fen' },
  ITEM_TUFLYA: { weight: 960, name: 'tuf' },
  ITEM_VANTUZ: { weight: 890, name: 'van' },
  ITEM_YAD: { weight: 850, name: 'yad' },
  ITEM_BANAN: { weight: 760, name: 'ban' },

  ITEM_WEIGHT_DELTA: 20,
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/shared/constants.js
 ** module id = 20
 ** module chunks = 0
 **/